<template lang="html">
	<div>
		<b-form-group :label="passwordText">
			<b-form-input v-model="$v.user.password.$model" :placeholder="passwordPlaceHolder" type="password" :state="validatePassword('password')" autocomplete="off"></b-form-input>
			<b-form-invalid-feedback v-if="!$v.user.password.required">Поле обязательно для заполнения</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.password.checkPasswordRegex1">Пароль должен содержать цифру</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.password.checkPasswordRegex2">Пароль должен содержать заглавную букву</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.password.checkPasswordRegex3">Пароль должен содержать маленькую букву</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.password.checkPasswordRegex4">Пароль должен содержать символ</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.password.checkPasswordRegex5">Пароль не должен содержать пробелы</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.password.checkPasswordRegex6">Минимальная длина пароля 8 символов</b-form-invalid-feedback>
		</b-form-group>
		<b-form-group label="Подтверждение пароля:">
			<b-form-input v-model="$v.user.password_confirm.$model" :placeholder="passwordPlaceHolder" type="password" :state="validatePassword('password_confirm')" autocomplete="off"></b-form-input>
			<b-form-invalid-feedback v-if="!$v.user.password_confirm.required">Поле обязательно для заполнения</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.password_confirm.sameAsPassword">Пароли должны совпадать</b-form-invalid-feedback>
		</b-form-group>
	</div>
</template>

<script>
import { required, requiredIf, sameAs, helpers } from 'vuelidate/lib/validators'

var passwordRegex1 = /^(?=.*\d)/
var passwordRegex2 = /^(?=.*[A-Z])/
var passwordRegex3 = /^(?=.*[a-z])/
var passwordRegex4 = /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_])/
var passwordRegex5 = /^(?!.*[\s])/
var passwordRegex6 = /^(.{8,})/
const checkPasswordRegex1 = helpers.regex('checkPasswordRegex1', passwordRegex1)
const checkPasswordRegex2 = helpers.regex('checkPasswordRegex2', passwordRegex2)
const checkPasswordRegex3 = helpers.regex('checkPasswordRegex3', passwordRegex3)
const checkPasswordRegex4 = helpers.regex('checkPasswordRegex4', passwordRegex4)
const checkPasswordRegex5 = helpers.regex('checkPasswordRegex5', passwordRegex5)
const checkPasswordRegex6 = helpers.regex('checkPasswordRegex6', passwordRegex6)

export default {
	name: 'BasePassword',
	props: {
		user: {
			type: Object,
		},
		passwordText: {
			type: String,
			default: 'Пароль:'
		},
		passwordPlaceHolder: {
			type: String,
			default: 'Введите пароль'
		},
		passwordRequired: {
			type: Boolean,
			default: true
		}
	},
	validations: {
		user: {
			password: {
				required: requiredIf(function() {
					return this.passwordRequired
				}),
				checkPasswordRegex1,
				checkPasswordRegex2,
				checkPasswordRegex3,
				checkPasswordRegex4,
				checkPasswordRegex5,
				checkPasswordRegex6
			},
			password_confirm: {
				required: requiredIf(function() {
					return this.passwordRequired
				}),
				sameAsPassword: sameAs('password')
			}
		}
	},
	methods: {
		validatePassword(name) {
			const { $dirty, $error } = this.$v.user[name]
			return $dirty ? !$error : null
		},
		resetValidation() {
			this.$v.user.$reset()
		}
	}
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/Manager/Shared/BasePassword.vue